import { Component } from "@angular/core";

@Component({
  selector: "app-teams1-content",
  templateUrl: "teams1-content.component.html",
})
export class Teams1ContentComponent {}
